var borders_default = {
  "borderT": "QFv5s",
  "borderB": "oBE2j",
  "borderL": "V8IG2",
  "borderR": "Nprpb"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
